/**
 * Playlist Editor Tour Step Definitions.
 * Declarative, engine-agnostic configuration for the Playlist Editor guide.
 */
export const playlistEditorTourConfig = {
  id: 'playlist-editor-onboarding',
  storageKey: 'triad_tour_playlist_editor_completed',
  steps: [
    {
      id: 'playlist-header',
      target: '[data-tour="playlist-header"]',
      titleKey: 'tour.playlistEditor.headerTitle',
      descriptionKey: 'tour.playlistEditor.headerDesc',
      position: 'bottom',
      align: 'start'
    },
    {
      id: 'playlist-autosave',
      target: '[data-tour="playlist-autosave"]',
      titleKey: 'tour.playlistEditor.autosaveTitle',
      descriptionKey: 'tour.playlistEditor.autosaveDesc',
      position: 'bottom',
      align: 'end'
    },
    {
      id: 'playlist-editor-content',
      target: '[data-tour="playlist-editor-content"]',
      titleKey: 'tour.playlistEditor.contentTitle',
      descriptionKey: 'tour.playlistEditor.contentDesc',
      position: 'top',
      align: 'center'
    }
  ]
};

export default playlistEditorTourConfig;
